import axios from "axios";
import { useEffect, useState } from "react";
import { FaQuran } from "react-icons/fa";
import StatCard from "./stat_card";

const CardTwo = ({ user }) => {
	const [stats, setStats] = useState({ totalCount: 0 });
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetchUserStats();
	}, []);

	const fetchUserStats = async () => {
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_API_URL}/api/v1/khatam-al-quran/user-stats`,
				{
					headers: {
						Authorization: `Bearer ${user.token}`,
					},
				}
			);
			const data = await response.data.data;
			setStats(data);
		} catch (error) {
			console.error("Failed to fetch user statistics:", error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<StatCard
			icon={<FaQuran />}
			label="Khatam Juzs"
			value={stats.totalCount}
			loading={loading}
			accentBg="bg-emerald-50"
			accentText="text-emerald-600"
			accentBar="from-emerald-500 to-emerald-400"
		/>
	);
};

export default CardTwo;
